/* Organza 04 cover background + preserved M-3 light and E-3 sparkles. */
(() => {
  'use strict';
  if (document.getElementById('bm-e3-background')) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canvas = document.createElement('canvas');
  canvas.id = 'bm-e3-background';
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:-1;';
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
    document.body.prepend(canvas);
    canvas.dataset.backgroundVersion = 'organza04-m3-v1';
    document.body.style.isolation = 'isolate';
    document.body.style.setProperty('--bm-page-background', 'transparent');
    document.body.style.setProperty('--bm-page-background-color', 'transparent');
  let width = 1, height = 1, offset = window.scrollY, target = offset;
  let time = 0, previous = 0, frame = 0;
  const wrap = (n, max) => ((n % max) + max) % max;
  function glow(x, y, radius, alpha) {
    const gradient = ctx.createRadialGradient(x, y, 0, x, y, radius);
    gradient.addColorStop(0, `rgba(255,255,255,${alpha})`);
    gradient.addColorStop(.6, `rgba(226,253,255,${alpha * .6})`);
    gradient.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = gradient;
    ctx.fillRect(x - radius, y - radius, radius * 2, radius * 2);
  }
  function star(x, y, radius, alpha) {
    ctx.save();
    ctx.translate(x, y);
    ctx.fillStyle = `rgba(255,255,255,${alpha})`;
    ctx.shadowColor = '#fff'; ctx.shadowBlur = 10;
    ctx.beginPath(); ctx.moveTo(0, -radius);
    ctx.quadraticCurveTo(radius * .15, -radius * .15, radius, 0);
    ctx.quadraticCurveTo(radius * .15, radius * .15, 0, radius);
    ctx.quadraticCurveTo(-radius * .15, radius * .15, -radius, 0);
    ctx.quadraticCurveTo(-radius * .15, -radius * .15, 0, -radius);
    ctx.fill(); ctx.restore();
  }
  function laceLight() {
    const p = offset / Math.max(height, 1) * .9;
    for (let j = 0; j < 5; j++) {
      const x = width * (.08 + j * .23 + .16 * Math.sin(p + j));
      const y = height * (.48 + .34 * Math.sin(j * 2 + p * .8));
      ctx.save();
      ctx.translate(x, y); ctx.rotate(.3 * j);
      ctx.scale(width * .3, height * .32);
      const gradient = ctx.createRadialGradient(0, 0, 0, 0, 0, 1);
      gradient.addColorStop(0, 'rgba(255,255,255,0.7)');
      gradient.addColorStop(.35, 'rgba(255,255,255,0.56)');
      gradient.addColorStop(1, '#ffffff00');
      ctx.fillStyle = gradient; ctx.fillRect(-1, -1, 2, 2);
      ctx.restore();
    }
  }
  const backgroundImage = new Image();
  const backgroundUrl = document.currentScript?.dataset.water;
  backgroundImage.onload = () => draw();
  if (backgroundUrl) backgroundImage.src = backgroundUrl;
  function draw() {
    ctx.clearRect(0, 0, width, height);
    const s = offset * .0009;
    ctx.fillStyle = '#edf6fc';
    ctx.fillRect(0, 0, width, height);
    if (backgroundImage.complete && backgroundImage.naturalWidth > 0) {
      const scale = Math.max(width / backgroundImage.naturalWidth, height / backgroundImage.naturalHeight);
      const imageWidth = backgroundImage.naturalWidth * scale;
      const imageHeight = backgroundImage.naturalHeight * scale;
      ctx.drawImage(backgroundImage, (width - imageWidth) / 2, (height - imageHeight) / 2, imageWidth, imageHeight);
    } else {
    const mistScroll = offset * .0007, t = time * .12;
    const base = ctx.createLinearGradient(0, 0, width, height);
    base.addColorStop(0, '#e5f3fb');
    base.addColorStop(.48, '#fcfeff');
    base.addColorStop(1, '#d8eaf5');
    ctx.fillStyle = base; ctx.fillRect(0, 0, width, height);
    function haze(x, y, radius, color) {
      const gradient = ctx.createRadialGradient(x, y, 0, x, y, radius);
      gradient.addColorStop(0, color); gradient.addColorStop(1, '#ffffff00');
      ctx.fillStyle = gradient; ctx.fillRect(x - radius, y - radius, radius * 2, radius * 2);
    }
    haze(width * (.12 + .07 * Math.sin(t + mistScroll)), height * .4, width * .62, '#a9d9eeaa');
    haze(width * .9, height * (.6 + .12 * Math.sin(t * .6 + mistScroll)), width * .5, '#c8ddf499');
    haze(width * .5, height * .32, width * .5, '#ffffffed');
    }
    laceLight();
    for (let i = 0; i < 60; i++) {
      const near = i % 4 === 0;
      const x = wrap(i * 157 + Math.sin(s * .5 + i) * 25, width + 100) - 50;
      const y = wrap(i * 133 - offset * (near ? .3 : .08), height + 180) - 90;
      glow(x, y, near ? 16 : 3, near ? .65 : .9);
    }
    for (let i = 0; i < 25; i++) {
      star(wrap(i * 173.71 + offset * .035, width + 50) - 25,
        wrap(i * 117.31 - offset * .025, height + 50) - 25,
        i % 7 === 0 ? 7 : 2,
        .2 + .65 * Math.pow(.5 + .5 * Math.sin(i * 2 + time * .8 + s * 3), 4));
    }

  }
  function resize() {
    width = window.innerWidth; height = window.innerHeight;
    const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    canvas.width = Math.round(width * dpr); canvas.height = Math.round(height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0); draw();
  }
  function tick(now) {
    frame = 0;
    if (document.hidden || reduced.matches) return;
    if (now - previous >= (width < 750 ? 50 : 32)) {
      time += Math.min((now - previous) / 1000, .06); previous = now;
      offset += (target - offset) * .12; draw();
    }
    frame = requestAnimationFrame(tick);
  }
  function sync() {
    cancelAnimationFrame(frame); frame = 0;
    if (document.hidden || reduced.matches) { draw(); return; }
    previous = performance.now(); frame = requestAnimationFrame(tick);
  }
  window.addEventListener('scroll', () => { target = window.scrollY; }, { passive: true });
  window.addEventListener('resize', resize, { passive: true });
  document.addEventListener('visibilitychange', sync);
  reduced.addEventListener('change', sync);
  window.addEventListener('pagehide', () => cancelAnimationFrame(frame));
  window.addEventListener('pageshow', sync);
  resize(); sync();
})();
